export const toggleDialog = (id) => {
    const dialog = document.getElementById(`${id}__dialog`);
    dialog.classList.toggle('hide');
    if (!dialog.classList.contains('hide')) {
        document.body.style.position = 'absolute';
        document.body.style.overflow = 'hidden';
    }
    else {
        document.body.style.position = null;
        document.body.style.overflow = null;
    }
};

//# sourceMappingURL=dialog-utils.js.map
